import { Box, Breadcrumb } from '@cowsquare/design';
import { Link } from 'gatsby';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { BreadcrumbWrapper } from '../../../BreadcrumbWrapper';
import { HTMLContent } from '../../../HTMLContent';
import { Field, RowLink } from '../../../MedicalContent';
import { Section } from '../../../Section';
import { Title } from '../../../Title';
import PageNotFound from '../../error/404';

const Logo = styled(Box).attrs({
  width: ['72px', '152px'],
  height: ['72px', '152px'],
})`
  background-image: url("${props => props.imgUrl}");
  background-position: center center;
  background-size: cover;
`;

const GET_EVENT_ORGANIZER_RECORD = gql`
  query getEventOrganizerRecord($id: uuid!) {
    record: hkdutest_event_organizers_by_pk(id: $id) {
      id
      name
      fax
      email
      content
      address
      phone
      logo {
        link
      }
    }
  }
`;

const Content = ({ id }) => {
  return (
    <Query query={GET_EVENT_ORGANIZER_RECORD} variables={{ id }}>
      {({ data, loading }) => {
        if (!loading && !R.prop('record', data)) {
          return <PageNotFound />;
        }

        const record = R.propOr(0, 'record', data);
        const title = R.propOr('', 'name', record);
        const photo = R.pathOr('', ['logo', 'link'], record);

        return (
          <Section>
            <Helmet>
              <title>{title} - HKDU CME</title>
            </Helmet>
            <BreadcrumbWrapper>
              <Breadcrumb>
                <Breadcrumb.Item linkProps={{ as: Link, to: '/cme/event-organizers' }}>
                  Event Organizers
                </Breadcrumb.Item>
                <Breadcrumb.Item>{title}</Breadcrumb.Item>
              </Breadcrumb>
            </BreadcrumbWrapper>
            <Box mt={[7, 8]} mx={[5, 0]}>
              {photo && <Logo imgUrl={photo} />}
              <Title mt={6} mb={7}>
                {title}
              </Title>
              <Box pb={8}>
                <Field
                  label="E-mail"
                  value={record.email}
                  render={value => <RowLink href={`mailto:${value}`}>{value}</RowLink>}
                />
                <Field label="Phone" value={record.phone} />
                <Field label="Fax" value={record.fax} />
                <Field label="Address" value={record.address} />
              </Box>
              {record.content && (
                <Box pb={8}>
                  {' '}
                  <HTMLContent html={record.content} />
                </Box>
              )}
            </Box>
          </Section>
        );
      }}
    </Query>
  );
};

export default Content;
